import classes from "../../dashboardComponents/DashboardComponents.module.scss";
import {Checkout} from "@fung-sdk/checkout"
import { Checkbox, FormControl, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";
import axios from "axios";
import ButtonLink from "../../UI/ButtonLink";
import { useRef, useState } from "react";
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'
import LoadingDots from "../../UI/LoadingDots";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DDD } from "../../../lib/ddd/ddd";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);


const FundPayPackage = ({onPaymentCompleted, onClose, packageData, packageArgs, ...props}) => {
    const [checkoutLoading, setCheckoutLoading] = useState();
    const [value, setValue] = useState(0);
    const [error, setError] = useState();
    const [state, setState] = useState(0);
    const [checkoutId, setCheckoutId] = useState();
    const [reccuring, setReccuring] = useState(true);
    const [mode, setMode] = useState("production"); //production, sandbox
    const myElementRef = useRef(null);
    
    const proceedToCheckout = () =>{
        if(checkoutLoading)
            return;
        if(!packageData || !packageArgs || !packageArgs.PackageId){
            setError("Unable to resolve number");
            return setTimeout(() => {setError(null);}, 5000);
        }
        goToCheckout();
        /*try{
            const amount = parseFloat(value)*100;
            goToCheckout(amount);
        }catch{
            setError("Unable to resolve number");
            setTimeout(() => {setError(null);}, 5000);
        }*/
    }

    const goToCheckout = () => {
        setCheckoutLoading(true);

        let packagePayment = {
            "Package" : packageArgs.PackageId,
            "PayType" : packageArgs.PayType,
            "Type" : "Package",
            "Reccuring" : reccuring
        }
        ddd.Rpc_ExecuteExtension("EUeInvoices.CreateFungCheckout", packagePayment).then(res => {
            if(!res?.result?.Result.id){
                setError("Unable to contact payment service. Please contact administrator.");
                setTimeout(() => {setError(null);}, 5000);
                setCheckoutLoading(false);
                return;
            }
            setCheckoutLoading(false);
            let checkoutId = res?.result?.Result.id;
            setCheckoutId(checkoutId);
            loadCheckout(checkoutId);
        });
    }

    const loadCheckout = (checkoutId) => {
        setState(1);
        const checkout = new Checkout({
            checkoutId: checkoutId,
            containerId: "paymentContainerModal",
            env: mode,
        })
        checkout.on("checkout:loaded", (e) => {
            
        })

        checkout.on("checkout:completed", (e) => {
            onPaymentCompleted(packageData, packageArgs);
            setState(2);
            clearIframeDiv();
        })
        checkout.on("checkout:invalid", (e) => {
            setState(0);
            setError("Unable to resolve payment")
            setTimeout(() => {setError(null);}, 5000);
            clearIframeDiv();
        })

        checkout.on("checkout:failed", (e) => {
            setState(0);
            setError("Unable to resolve payment")
            setTimeout(() => {setError(null);}, 5000);
            clearIframeDiv();
        })
        checkout.render();
    }

    const clearIframeDiv = () => {
        const container = document.getElementById("paymentContainerModal");
        if (container == null)return;

        container.innerHTML = null;
    }



    return(
        
        <div>
            {state === 0 && <>
                {mode==="production" && 
                <div class="alert alert-danger" role="alert">
                    This version is in production mode!!
                </div>}
                <div className="mb-3" style={{textAlign:"center"}}>Are you sure you want to purchase the following package?</div>
                <div className="text-center">Package: <span className={classes["packageConfirmSpan"]}>{packageData.PackageName}</span></div>
                <div className="text-center">Price: <span className={classes["packageConfirmSpan"]}>{packageArgs.PayType ==="Monthly" ?  packageData.PricePerMonth : packageData.PricePerYear}€</span></div>
                <div className="text-center">Billing: <span className={classes["packageConfirmSpan"]}>{packageArgs.PayType}</span></div>
                <div className="text-center"><Checkbox id="slac2" checked={reccuring} size="small" onChange={(e) => setReccuring(e.target.checked)}/>
                    <label for="slac2">Automatically charge each {packageArgs.PayType ==="Monthly" ? "month" : "year"}</label>
                </div>
                {error && 
                <div class="alert alert-danger" role="alert">
                    {error}
                </div>}
                {checkoutLoading && <LoadingDots/>}
                {!checkoutLoading && <div className="m-2 mt-4" style={{textAlign:"center"}}>
                    <ButtonLink className="px-4 py-1" onClick={proceedToCheckout}>
                        Continue
                    </ButtonLink>
                </div>
                }
            </>}
            {state ===2 && <>
                <div style={{textAlign:"center"}}>
                    <CheckCircleIcon style={{color:"green", fontSize:"3rem"}}/>
                </div>
                <div style={{textAlign:"center",color:"green", fontSize:"1rem"}}>
                    Payment successful
                </div>
                <div className="m-2 mt-4" style={{textAlign:"center"}}>
                    <ButtonLink className="px-4 py-1" onClick={onClose}>
                        Continue
                    </ButtonLink>
                </div>
            </>}
            <div id="paymentContainerModal" style={{textAlign:"center"}} ref={myElementRef}></div>
        </div>
    )
}

export default FundPayPackage;